import { FormLabel } from "@mui/material";
import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";

import TextField from "@readai/common/components/TextField";
import Stack from "@readai/pulse/components/Stack";

export const RecommendedTimeIndicator = styled(Box)(({ theme }) => ({
  height: "8px",
  width: "8px",
  borderRadius: "50%",
  backgroundColor: theme.palette.shades.meadow[500],
}));

export const InputWrapper = styled(Stack)(({ theme }) => ({
  width: "100%",
  rowGap: theme.spacing(0.5),
  alignItems: "start",
  "& .MuiFormControl-root": {
    minWidth: 0,
    width: "100%",
  },
  "& .MuiInputBase-root": {
    "input, textarea": {
      fontSize: "0.875rem",
    },
  },
  "& .text-field__textarea .MuiInputBase-root": {
    padding: theme.spacing(1, 1.5),
  },
}));

export const StyledTextField = styled(TextField)({
  input: {
    padding: "7px 19px 7px 14px",
    fontWeight: 400,
  },
  width: "100%",
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
  },
});

export const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  fontSize: "0.85rem",
  color: theme.palette.shades.neutral[800],
  fontWeight: 500,
}));

export const Card = styled(Stack)({
  backgroundColor: "#fff",
  borderRadius: "8px",
  overflow: "hidden",
});

export const NotificationCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: "95%",
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(3),
  },
  [theme.breakpoints.up("md")]: {
    maxWidth: "900px",
  },
}));
